export default "__VITE_ASSET__Cshs99Km__"